import axios from '../utils/axios';

export default function unpublishCourse(adminId, courseId, data) {
    return (
        axios.post('/admin/' + adminId +'/courses/course/unpublish/' + courseId ,  data )
    )
}
